import { defineStore } from 'pinia'
import { StoreHelper } from '../../helpers/storeHelper'

export const useWpStore = defineStore('wp', {
  state: () => ({}),
  getters: {
    eventShortCode(): string | null {
      const { atts } = StoreHelper.loadRootState()
      const searchParams = new URLSearchParams(window.location.search)
      return (atts || {}).tenantCode || searchParams.get('code')
    },
    getLabel() {
      const { pluginOption } = StoreHelper.loadRootState()
      return (name: string) => {
        return {
          ...(pluginOption || {}).label || {},
          ...((pluginOption || {})[name] || {}).label || {}
        }
      }
    },
    getMessage() {
      const { pluginOption } = StoreHelper.loadRootState()
      return (name: string) => {
        return {
          ...(pluginOption || {}).message || {},
          ...((pluginOption || {})[name] || {}).message || {}
        }
      }
    },
    locale() {
      const { atts } = StoreHelper.loadRootState()
      return atts ? atts.locale : null
    },
    pageSlugEventList() {
      const { pluginOption } = StoreHelper.loadRootState()
      return (pluginOption || {}).pageSlugEventList
    },
    pageSlugEventRegister() {
      const { pluginOption } = StoreHelper.loadRootState()
      return (pluginOption || {}).pageSlugEventRegister
    },
    pageSlugEventRegistration() {
      const { pluginOption } = StoreHelper.loadRootState()
      return (pluginOption || {}).pageSlugEventRegistration
    },
    pageSlugTicketing() {
      const { pluginOption } = StoreHelper.loadRootState()
      return (pluginOption || {}).pageSlugTicketing
    },
    tenantCode() {
      const { atts, pluginOption } = StoreHelper.loadRootState()
      return (pluginOption || {}).tenantCode || (atts || {}).tenantCode
    },
    wpNonce() {
      const { pluginOption } = StoreHelper.loadRootState()
      return (pluginOption || {}).wpNonce || ''
    }
  }
})
